// Team (/rechnung/team); Inhalt in seiten/Team.tsx (erst bei Bedarf geladen)
import { faul } from './faul';

export const TeamSeite = faul(() => import('./seiten/Team'));
